import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
// import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { useDispatch, useSelector,connect } from "react-redux";
import { uploadPrescription } from "../../Redux/Actions";
import { FaPlusSquare } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
// import "./Uploadprescription.css";
// import ImagingHeader from "./ImagingHeader";
import ImagingNewHeader from "./ImagingNewHeader";
import ImagingFooter from "./ImagingFooter";
import TopNav from "../TopNav/TopNav";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { AiOutlineDoubleRight } from "react-icons/ai";
import logoTrans from "../../Assets/logo-transparent.png";
import homePin from "../../Assets/newAsset/pin.svg";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Address from "../../Pages/Uploadprescription/Address";
import { GiTriquetra } from "react-icons/gi";
import { Scroll } from "../../components/Scroll function/scroll";
import PatientActions from "../Cart/PatientDetailsAction"

function Imagingprescription(props) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [openSuccModel, setSucc] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  //cont
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  const closeHandler = (para) => {
    setOpen(para);
  };
  // const [name, setName] = useState("");
  // const [mobile, setMobile] = useState("");
  const [filename, setFilename] = useState("");
  const [previewName, setPreview] = useState("");
  const [previewError, setFileError] = useState("");
  const [usertoken, setToken] = useState("");
  //GETTING TOKEN

  const { error } = useSelector((state) => state.prescription);

  //states for input
  const [firstName, setfirstName] = useState("");
  const [userName, setUserName] = useState("");
  const [nameError, setNameEror] = useState("");

  const [mobile, setMobile] = useState("");
  const [phoneEror, setPhoneError] = useState("");

  const [patientName, setPatientName] = useState("");
  const [patientError, setpatientEror] = useState("");

  const [age, setAge] = useState("");
  const [ageError, setAgeError] = useState("");

  const [gender, setGender] = useState("");

  const [fileSelected, setFileSelected] = useState();

  const [testname, setTestname] = useState("");
  const [isSubmit, setSubmit] = useState(false);
  const [address, setAddress] = useState("");

  const [disable, setDisable] = useState(false);

  const [success, setSucess] = useState(false);
  const [patientMapAddress, setPatientMapAddress] = useState("");

  const handleSubmit = () => {
    // console.log("prssd");
    const userProfile = JSON.parse(localStorage.getItem("user"));
    if (userProfile && userProfile !== "") {
      history.push("/imaging");
      dispatch(EmptyCart(userProfile && userProfile.token));
    } else {
      history.push("/imaging");
    }
  };
  //handel name validation

  const handelUserName = (e) => {
    setfirstName(e.target.value);
    setUserName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  //handel patient name

  const handelPatientName = (e) => {
    setPatientName(e.target.value);
    const characterRegex =/^([A-Za-z]+[ ]?)+$/;
    setpatientEror("");
    if (!e.target.value.match(characterRegex)) {
      setpatientEror("invalid user name");
    }
    if (e.target.value == "") {
      setpatientEror("");
    }
  };

  useEffect(() => {
    Scroll();
  }, []);

  const validatePhoneNumber = (e) => {
    setMobile(e.target.value);
    setPhoneError("");
    console.log(e.target.value);
    let phoneno = /^\d{10}$/;
    if (!e.target.value.match(phoneno) || parseInt(mobile[0]) < 6) {
      setPhoneError("Enter a valid number");
    } else if (mobile > 7) {
      setPhoneError("");
    } else {
      setPhoneError("");
    }
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  //  const handelPhoneChange = (e) => {
  //   setUserNumber(e.target.value);
  //   setPhoneEror("");
  // };

  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));

    const token = datakey.token;

    setToken(token);
  }, []);

  const history = useHistory();
  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user"));

    if (!userProfile) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props?.getProfileDetails(token)
    }
  }, [])

  useEffect(() => {
    // console.log(props?.userProfile , "<<<<<")
    if (props?.userProfile?.username && props?.userProfile?.fullname){
      setMobile(props?.userProfile?.phonenumber);
      setfirstName(props?.userProfile?.fullname);
    }
    return
  }, [props?.userProfile]);

  //DISABLED BUTTON FUNCTION

  //DISABLED BUTTON FUNCTION
  useEffect(() => {
    if (
      nameError !== "" ||
      phoneEror !== "" ||
      patientError !== "" ||
      ageError !== "" ||
      previewError !== ""
    ) {
      setDisable(true);

      console.log(nameError, phoneEror, patientError, ageError);
    } else {
      setDisable(false);
    }
  }, [nameError, phoneEror, patientError, ageError, previewError]);

  //Handel submit form function

  const handelfile = (e) => {
    console.log("filename ", e.target?.files[0]?.name);
    setFileSelected(e.target?.files[0]);

    var myTruncatedString =
      e.target?.files[0]?.name?.substring(0, 10) + e.target?.files[0]?.type;

    setPreview(myTruncatedString);
    const filePath = e.target.value;
    var allowedExtensions = /(\.png|\.pdf|\.jpg|\.jpeg)$/i;

    if (e.target?.files[0]?.size > 5000000) {
      setFileError("File size should be less then 5 MB");
    } else if (allowedExtensions.exec(filePath)) {
      // setPreview(e.target.files[0].name);

      var myTruncatedString =
        e.target?.files[0]?.name.substring(0, 10) +
        "." +
        e.target?.files[0]?.type;

      setPreview(myTruncatedString);
      setFileError("");
      var file = e.target?.files[0];
      getBase64(file).then((data) => {
        setFilename(data);
        console.log(data);
      });
    } else {
      setFilename("");
      console.log("inside else", e.target?.files[0]);
      setFileError("invalid file type");
    }
  };

  //model div
  const SuccessModel = () => {
    return (
      <div className="SuccessMsg_upload">
        <h2>
          Hi {userName}, we have received your request for test sample
          collection. We shall call you in few minutes to confirm the details.
          For any queries please call us at{" "}
          <a href="tel:+91-898 898 0303">898 898 0303 </a> - Team Redcliffe Labs
        </h2>
      </div>
    );
  };

  const handelAge = (e) => {
    setAge(e.target.value);

    if (e.target.value > 110 || e.target.value < 0) {
      setAgeError("Enter valid age");
    } else {
      setAgeError("");
      console.log(mobile);
    }
  };

  const handelUpload = (e) => {
    e.preventDefault();

    let formData = new FormData();
    console.log("form submitted");
    setSubmit(true);
    // formData.append("base64file", filename);
    formData.append("name", patientName);
    formData.append("age", age);
    formData.append("address", patientMapAddress);
    formData.append("testname", testname);
    formData.append("mobile", mobile);
    formData.append("gender", gender);
    formData.append("parent_name", firstName);
    formData.append("url", "/imaging");
    if (fileSelected) {
      formData.append("image", fileSelected);
    }
    if (patientName !== "" && isSubmit) {
      dispatch(uploadPrescription(formData, usertoken, "imaging"));
      setAge("");
      setPatientMapAddress("");
      setfirstName("");
      setFilename("");
      setMobile("");
      setPatientName("");
      setGender("");
      setTestname("");
      setPreview("");
      setSubmit(false);
      openSucess(true);
    }

    // setSucess(true);
    // setTimeout(() => {
    //   setSucess(false);
    // }, 2000);

    // console.log("sd", body, formData);
  };
  //changefilein base 64 string
  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  return (
    <div>
      {/* <TopNav isImagine={true} /> */}
      <ImagingNewHeader />

      <div className="UploadPrescriptiopDiv">
        <div className="main__div uploadPrescriptionMarginTop">
          <div className="child__divUpload">
            <div className="com__Logo">
              <img
                style={{ marginBottom: "15px", marginLeft: "-15px" }}
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e297bdda-8a10-4cf2-b567-c0d2d911e32c.webp"
              ></img>
              <span className="text_pink">Healthy India Ki Trusted Lab</span>
            </div>
            <div className="first_text">
              <span>
                A speciality division of steadfast radiology services,
                well-equipped with over 100+ physicians and medical experts in
                state-of-the-art laboratories. Our graduates of accredited
                radiology residencies are committed to providing quality image
                interpretations in which procedures are performed following
                NABL, ISO and ICMR guidelines.
              </span>
            </div>
            <div className="first_text">
              <p>
                {" "}
                <span className="subKeyHead">Popular tests:</span> PET Scan, CT
                Scan, Mammography, MRI Scan, ECHO, X-Ray, TMT, Ultrasound
              </p>
            </div>
            {/* comment */}
            {/* Upload via whatsapp prescription */}
            <div className="waBtn_container">
              <a href="https://api.whatsapp.com/send?phone=918988980101">
                <span className="watsap">
                  <RiWhatsappFill className="wtsapIcon" />
                </span>
                <span className="textt">
                  You can also upload your prescription through WhatsApp.
                </span>
              </a>
            </div>

            {/* <div className="waBtn_container">
              <a href="https://api.whatsapp.com/send?phone=918988988787&amp;text=Upload Prescription Here.">
                <span className="watsap">
                  <RiWhatsappFill className="wtsapIcon" />
                </span>
                <span className="textt">
                  You can also upload your prescription through WhatsApp.
                </span>
              </a>
            </div> */}

            {/**form for upload prescription */}
            <form
              className="uploadform__prescription"
              id="myForm"
              onSubmit={handelUpload}
            >
              <div className="formSection_upload">
                <span>What is your contact information?</span>
                <div className="formparent_upload">
                  <div className="inputFields__input ">
                    <input
                      type="text"
                      required
                      value={firstName}
                      onChange={handelUserName}
                      placeholder="Enter Full Name"
                    />
                    <span className="formError">
                      {nameError == "" ? null : nameError}
                    </span>
                  </div>
                  <div className="inputFields__input ">
                    <input
                      type="number"
                      className="typeNumber"
                      required
                      value={mobile}
                      onChange={validatePhoneNumber}
                      placeholder="Enter Phone Number"
                    />
                    <span className="formError">
                      {phoneEror == "" ? null : phoneEror}
                    </span>
                  </div>
                </div>
              </div>
              {/**Section 2 */}
              <div className="formSection_upload">
                <span>Add patient & test details</span>
                <div className="inputFields__input ">
                  <input
                    type="text"
                    required
                    onChange={handelPatientName}
                    value={patientName}
                    placeholder="Enter Full Name"
                  />
                  <span className="formError">
                    {patientError == "" ? null : patientError}
                  </span>
                </div>
                <div className="ageInputs ">
                  <div className="divideTwo">
                    <input
                      type="number"
                      required
                      className="ageInputDiv  typeNumber"
                      placeholder="Age"
                      onChange={handelAge}
                      value={age}
                    />
                    <span className="formError">
                      {ageError == "" ? null : ageError}
                    </span>
                  </div>

                  <select
                    onChange={(e) => setGender(e.target.value)}
                    value={gender}
                    className="ageInputDiv"
                    required
                  >
                    <option value="" disabled selected>
                      Gender
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="inputFields__input ">
                  <input
                    type="text"
                    value={testname}
                    onChange={(e) => setTestname(e.target.value)}
                    placeholder="Enter Test Details like: RTPCR, Vitamin D, CBC, B12.."
                  ></input>
                </div>

                <div className="upload_presDivfile">
                  <span>
                    {previewName == "" ? "Upload Prescription" : previewName}{" "}
                  </span>
                  <div className="uploadButton_html">
                    <label htmlFor="uploadpres" className="uploadButton_htmlUP">
                      Browse File <FaPlusSquare />
                    </label>

                    <input
                      id="uploadpres"
                      type="file"
                      hidden
                      onChange={handelfile}
                      placeholder="upload prescription"
                    ></input>
                  </div>
                </div>
                <p className="formError">
                  {previewError == "" ? null : previewError}
                </p>
                <div></div>
              </div>
              {/**Section 3 */}
              <div className="formSection_upload">
                <span> Address for collection?</span>
                <div
                  className="inputFields__input"
                  style={{
                    width: "98%",
                    border: " 1px solid #E3E3E3",
                    background: "white",
                  }}
                >
                  <input
                    style={{
                      width: "90%",
                      height: "47px",
                      border: "none",
                      margin: "0",
                    }}
                    required
                    className="addDress"
                    type="text"
                    onChange={(e) => e.target.value}
                    value={patientMapAddress}
                    placeholder="+ Add Address"
                    onClick={onOpenModal}
                  ></input>
                  <img src={homePin} alt="pinImg"></img>
                  <div className="uploadpRes">
                    {/**showCloseIcon={false} */}
                    <Modal
                      open={open}
                      onClose={onCloseModal}
                      showCloseIcon={false}
                      center
                      classNames={{
                        overlay: "addressModalOverlay",
                        modal: "addressModal",
                      }}
                    >
                      <Address
                        closeModel={onCloseModal}
                        setPatientMapAddress={setPatientMapAddress}
                      />
                    </Modal>
                  </div>
                </div>
              </div>
              {/**SUBMIT bUTTON */}
              <span className="successMsg">{success ? "success" : null}</span>
              {console.log("disable", disable)}
              <button
                disabled={disable ? "disabled" : null}
                className={disable ? "disabled submitUpload" : "submitUpload"}
                type="submit"
              >
                Book Test <AiOutlineDoubleRight />
              </button>
            </form>

            <Modal open={openSuccModel} onClose={closeSuccess} center>
              <SuccessModel />
            </Modal>
          </div>
        </div>
      </div>
      <ImagingFooter telNumber="898 898 0101" />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Imagingprescription)),
};
